// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"fc1ca8f60bf3cfaf3500","655":"b245d977465efa9b0dc7"}[chunkId] + ".js";
};